/**
 * Quiet Framework offer (#2079).
 * Ready is the #2073 rule: main character, want, and what's in the way
 * (plot-ready enough_solid). A Framework already on the book ends the offer.
 */

export function frameworkOfferVisible({ ready = false, hasFramework = false } = {}) {
  return ready === true && !hasFramework;
}

/** The published explainer's own title is the link. No row, no link. */
export function explainerLinkFrom(payload) {
  const row = payload && Object.prototype.hasOwnProperty.call(payload, 'data')
    ? payload.data
    : payload;
  if (!row || typeof row !== 'object') return null;
  const id = String(row.id || '').trim();
  const title = String(row.title || '').trim();
  if (!id || !title) return null;
  return { id, title };
}
